import {stripQueryParams} from "../utils/stringUtils";

let submenus = $('.menu-sibling-item.has-children');

submenus.on('mouseenter', function () {
    const $this = $(this);
    let container = $('.nav-holder');
    let containerOffset = container.offset().left;
    let remainOffset = $this.offset().left - containerOffset;
    let elementWidth = $this.outerWidth();
    let remainingWidth = container.outerWidth() - remainOffset - elementWidth;
    $this.find('.menu-sibling-sibling').css('width', remainingWidth);
});

let headMenu = $('.nav-menu ul li');
let headNavHolder = $('.nav-holder');
headMenu.on('mouseenter', function () {
    let offsetSpacer = 5;
    const windowWidth = $(window).width();
    const headNavHolderOuterWidth = headNavHolder.outerWidth();
    const $this = $(this);
    let menuSibling = $this.find('.menu-sibling');
    const menuSiblingOffset = $this.offset().left - ((windowWidth - headNavHolderOuterWidth) / 2);
    if (menuSibling.length !== 0) {
        let menuSiblingCalc = menuSibling.outerWidth() + menuSiblingOffset + offsetSpacer;
        if (menuSiblingCalc >= headNavHolderOuterWidth) {
            menuSibling.css('left', 'auto');
            menuSibling.css('right', '0px');
        } else {
            menuSibling.css('left', '');
        }
    }
});


const currentPageUrl = window.location.href;

$('.nav--alt a').each(function () {
    const menuItemUrl = $(this).attr('href');
    const defaultHref = $(this).data('default-href');

    if (currentPageUrl === menuItemUrl || stripQueryParams(currentPageUrl) === defaultHref) {
        $(this).addClass('active');
    }
});

$('.menu-sibling-item-holder a').each(function () {
    const menuItemUrl = $(this).attr('href');
    const parentMenuItem = $(this).closest('.has-children');

    if (currentPageUrl === menuItemUrl) {
        $(this).addClass('active');
        parentMenuItem.addClass('active');
    }
});